import z from 'zod';
import { entity, userRef, customerRef, assetGroupRef, string, } from '../common';
export const customerUserRelation = z.object({
    ...entity.shape,
    migrationKey: string.optional(),
    user: userRef,
    customer: customerRef,
    roles: string.array(),
    assetGroupRestrictions: assetGroupRef.array().nullish(),
});
